import React, { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie-consent')) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: '#1f2937', color: '#e5e7eb', padding: '1rem 2rem',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: '1rem', flexWrap: 'wrap', boxShadow: '0 -2px 10px rgba(0,0,0,0.3)',
      fontSize: '0.9rem',
    }}>
      <span>
        Bu site çerezleri kullanmaktadır. Devam ederek{' '}
        <a href="/cookie-policy" style={{ color: '#818cf8', textDecoration: 'underline' }}>çerez politikamızı</a>{' '}
        kabul etmiş olursunuz.
      </span>
      <button onClick={accept} style={{
        padding: '0.5rem 1.5rem', background: '#6366f1', color: '#fff',
        border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600,
        whiteSpace: 'nowrap',
      }}>
        Kabul Et
      </button>
    </div>
  );
}
